export default __webpack_public_path__ + "static/media/slider.a66e3206.png";